import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";

/** Настройки логистики: организации, среди которых выбирают на точке рейса. */
export function LogisticsSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Логистика"
          subtitle="Организации для выбора на точке рейса."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Логистика"
        subtitle="Организации для выбора на точке рейса."
      />
      <OrgWhitelistCard
        title="Организации для логистики (выбор на точке рейса)"
        field="logistics_org_refs"
        current={data.logistics_org_refs}
      />
    </div>
  );
}
